var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.921,
    x2: 254.921,
    xlinkHref: "#lg1",
    y1: 424.111,
    y2: 509.764
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07485e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2708,
    stopColor: "#074459",
    stopOpacity: 0.271
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#05394a",
    stopOpacity: 0.597
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9505,
    stopColor: "#032632",
    stopOpacity: 0.951
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.992,
    x2: 368.957,
    xlinkHref: "#lg2",
    y1: 486.518,
    y2: 365.944
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fce9cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbd95"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.921,
    x2: 254.921,
    xlinkHref: "#lg3",
    y1: 363.924,
    y2: 392.099
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.97,
    x2: 221.302,
    xlinkHref: "#lg1",
    y1: 377.777,
    y2: 409.617
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.753,
    x2: 336.277,
    xlinkHref: "#lg1",
    y1: 369.863,
    y2: 402.571
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.104,
    x2: 150.825,
    xlinkHref: "#lg3",
    y1: 210.333,
    y2: 236.054
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.87,
    x2: 397.591,
    xlinkHref: "#lg3",
    y1: 210.333,
    y2: 236.054
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.139,
    x2: 303.227,
    xlinkHref: "#lg3",
    y1: 122.251,
    y2: 294.536
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.765,
    x2: 249.014,
    y1: 363.127,
    y2: 298.496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63950"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.921,
    x2: 254.921,
    y1: 331.223,
    y2: 359.103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9545b"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa68e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9766e"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.724,
    x2: 237.541,
    xlinkHref: "#lg4",
    y1: 324.632,
    y2: 60.813
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.921,
    x2: 254.921,
    xlinkHref: "#lg4",
    y1: 213.008,
    y2: 373.642
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.055,
    x2: 319.858,
    xlinkHref: "#lg5",
    y1: 111.678,
    y2: 194.936
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.52,
    x2: 254.697,
    y1: 72.883,
    y2: 169.684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.174,
    x2: 130.174,
    xlinkHref: "#lg5",
    y1: 176.9,
    y2: 185.259
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-1 0 0 1 1859.389 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 1479.721,
    x2: 1479.721,
    xlinkHref: "#lg5",
    y1: 176.9,
    y2: 185.259
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.921,
    x2: 254.921,
    xlinkHref: "#lg5",
    y1: 180.376,
    y2: 189.506
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(.375 -.927 .927 .375 2289.654 -1426.019)",
    gradientUnits: "userSpaceOnUse",
    x1: -2290.905,
    x2: -2301.143,
    xlinkHref: "#lg5",
    y1: -1339.118,
    y2: -1320.537
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(-.375 -.927 -.927 .375 -1920.767 -1426.019)",
    gradientUnits: "userSpaceOnUse",
    x1: -2343.737,
    x2: -2353.976,
    xlinkHref: "#lg5",
    y1: -1469.796,
    y2: -1451.215
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.602,
    x2: 181.47,
    xlinkHref: "#lg6",
    y1: 223.976,
    y2: 164.219
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.339,
    x2: 221.488,
    xlinkHref: "#lg5",
    y1: 176.339,
    y2: 227.487
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.152,
    x2: 301.019,
    xlinkHref: "#lg6",
    y1: 223.976,
    y2: 164.219
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.889,
    x2: 341.037,
    xlinkHref: "#lg5",
    y1: 176.339,
    y2: 227.487
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(.934 .358 -.358 .934 105.998 -8.931)",
    gradientUnits: "userSpaceOnUse",
    x1: 117.356,
    x2: 79.312,
    xlinkHref: "#lg3",
    y1: 234.198,
    y2: 373.209
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(.934 .358 -.358 .934 105.998 -8.931)",
    gradientUnits: "userSpaceOnUse",
    x1: 84.493,
    x2: 124.671,
    xlinkHref: "#lg4",
    y1: 339.796,
    y2: 263.766
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.916,
    x2: 317.296,
    xlinkHref: "#lg2",
    y1: 471.829,
    y2: 405.568
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.96,
    x2: 300.545,
    xlinkHref: "#lg1",
    y1: 365.23,
    y2: 438.008
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf00"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.009,
    x2: 65.308,
    xlinkHref: "#lg7",
    y1: 186.979,
    y2: 229.503
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(.819 .574 -.574 .819 -559.441 224.921)",
    gradientUnits: "userSpaceOnUse",
    x1: 432.182,
    x2: 483.478,
    xlinkHref: "#lg7",
    y1: -436.328,
    y2: -393.806
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-1 0 0 1 787.157 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 316.506,
    x2: 367.804,
    xlinkHref: "#lg7",
    y1: 265.092,
    y2: 307.615
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientTransform: "matrix(-.819 .574 .574 .819 1346.598 224.921)",
    gradientUnits: "userSpaceOnUse",
    x1: 709.585,
    x2: 760.882,
    xlinkHref: "#lg7",
    y1: -535.434,
    y2: -492.912
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(-.819 -.574 .574 -.819 1346.598 -1772.327)",
    gradientUnits: "userSpaceOnUse",
    x1: -507.577,
    x2: -456.283,
    xlinkHref: "#lg7",
    y1: -2271.333,
    y2: -2228.812
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m503.352 457.049c13.726 15.453 3.939 39.931-16.655 41.696-58.99 5.056-137.095 8.118-222.782 8.118-94.85 0-180.404-3.754-241.02-9.794-20.343-2.027-30.103-26.33-16.42-41.52.103-.114.206-.229.309-.343 60.913-67.677 149.214-110.22 247.442-110.22 97.173 0 184.562 41.584 245.427 107.965 1.244 1.357 2.477 2.723 3.699 4.098z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.654 452.953c-60.721-66.223-147.84-107.763-244.736-107.96v161.86c2.99.008 5.989.011 8.997.011 85.688 0 163.792-3.062 222.782-8.118 20.593-1.765 30.381-26.243 16.655-41.696-1.222-1.376-2.455-2.742-3.698-4.097z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.921,
    cy: 375.908,
    fill: "url(#SVGID_3_)",
    rx: 42.003,
    ry: 26.039
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m163.54 339.827v19.604c0 3.603.792 7.151 2.307 10.334l26.242 55.14c3.429 7.205 11.541 9.787 17.864 5.688l44.968-29.156z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.302 339.827v19.604c0 3.603-.792 7.151-2.307 10.334l-26.242 55.14c-3.429 7.205-11.541 9.787-17.864 5.688l-44.968-29.156z",
    fill: "url(#SVGID_5_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m131.538 251.836c-14.929 0-27.031-12.102-27.031-27.031v-16.076c0-14.929 12.102-27.031 27.031-27.031 14.929 0 27.031 12.102 27.031 27.031v16.076c0 14.929-12.102 27.031-27.031 27.031z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.304 251.836c-14.929 0-27.031-12.102-27.031-27.031v-16.076c0-14.929 12.102-27.031 27.031-27.031 14.929 0 27.031 12.102 27.031 27.031v16.076c0 14.929-12.102 27.031-27.031 27.031z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m254.921 382.56c67.541 0 123.103-53.399 125.543-120.895 1.046-28.939 1.046-57.899 0-86.838-2.44-67.497-58.002-120.895-125.543-120.895-67.541 0-123.103 53.399-125.543 120.895-1.046 28.939-1.046 57.899 0 86.838 2.44 67.496 58.002 120.895 125.543 120.895z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m303.724 315.415c-.206-5.069-3.204-9.119-7.958-10.402-26.635-7.187-55.057-7.187-81.691 0-4.754 1.283-7.752 5.333-7.958 10.402-.796 19.603 3.884 35.692 12.546 48.88 1.756 2.673 4.994 4.645 8.554 5.241 18.611 3.118 36.795 3.118 55.407 0 3.56-.596 6.798-2.568 8.553-5.241 8.663-13.188 13.343-29.277 12.547-48.88z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.168 348.819c1.892 2.901.543 7.496-2.296 7.827-8.132.949-18.899 1.524-30.711 1.524-13.075 0-24.869-.705-33.225-1.838-2.804-.381-4.15-4.943-2.263-7.794.014-.021.028-.043.043-.064 8.397-12.704 20.569-20.69 34.11-20.69 13.396 0 25.442 7.806 33.833 20.267.17.253.34.51.509.768z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m362.665 174.22c-.366-.299-3.419-3.637-4.93-4.61-1.752-2.722-4.504-4.711-7.742-5.456-23.441-5.396-47.152-5.396-70.593 0-4.362 1.004-7.846 4.261-9.184 8.532-.889 2.839-1.628 5.684-2.251 8.531-3.779-2.381-8.247-3.767-13.044-3.767-2.566 0-5.033.408-7.356 1.141l-9.38-8.981c-1.752-2.722-4.504-4.71-7.742-5.456-23.441-5.396-47.152-5.396-70.593 0-4.362 1.004-7.846 4.261-9.184 8.532-.16.511-.299 1.023-.45 1.534h-20.808c-.008.202-.022.403-.029.606-.001.038-.002.076-.004.114-.101 2.791-.184 5.583-.265 8.375-.068 2.419-.13 4.837-.185 7.256 0 .009 0 .018-.001.027l17.422 15.119c.398 7.978 1.834 15.95 4.32 23.888.899 2.87 2.77 5.278 5.222 6.856l139.447 139.447c48.035-16.302 83.199-60.859 85.129-114.244 1.046-28.939 1.046-57.899 0-86.838-.007-.203-.021-.404-.03-.606z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.667 282.3h-15.492c-12.415 0-22.087-9.153-20.759-19.645l8.099-63.997h40.811l8.099 63.997c1.329 10.492-8.343 19.645-20.758 19.645z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m129.732 216.844 2.326-34.698c1.245-18.569 11.904-35.419 27.895-44.489 7.928-4.497 16.78-6.858 25.675-6.858h67.874c24.662 0 48.08-9.709 64.852-26.737l16.347 26.136c3.916 6.26 9.41 11.48 15.926 15.107 13.345 7.43 22.218 21.435 23.171 36.847l1.53 24.739c.286 4.63 4.143 8.399 8.612 8.399 3.721 0 6.779-2.642 7.408-6.39l11.087-66.075c3.178-18.939 3.966-37.975 2.42-56.684-2.307-27.92-29.73-48.439-57.407-43.595-35.442-32.036-83.954-45.533-130.63-36.815l-40.58 7.579c-36.789 6.871-65.006 38.263-66.137 75.078l-1.206 39.253c-.546 17.763.319 35.774 2.628 53.869l4.694 36.792c.419 3.282 3.022 5.638 6.238 5.638 3.756 0 7.014-3.184 7.277-7.096z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.449 42.545c-35.443-32.035-83.955-45.532-130.631-36.814l-40.58 7.579c-36.789 6.871-65.006 38.263-66.137 75.078l-1.206 39.253c-.546 17.763.319 35.774 2.628 53.869l4.694 36.792c.419 3.282 3.022 5.638 6.238 5.638 3.756 0 7.015-3.183 7.277-7.096l2.326-34.698c1.245-18.569 11.904-35.419 27.895-44.489 7.928-4.497 16.78-6.858 25.675-6.858h67.874c24.662 0 48.08-9.709 64.852-26.737 0-.001-10.412-43.114 29.095-61.517z",
    fill: "url(#SVGID_14_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m154.851 190.598h-41.166c-4.523 0-8.189-3.666-8.189-8.189 0-4.523 3.666-8.189 8.189-8.189h41.166z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.99 190.598h41.166c4.523 0 8.189-3.666 8.189-8.189 0-4.523-3.666-8.189-8.189-8.189h-41.166z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m243.382 195.336c2.303-3.989 6.602-6.68 11.539-6.68s9.236 2.691 11.539 6.68h12.076c-2.899-10.319-12.37-17.887-23.615-17.887s-20.716 7.568-23.615 17.887z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m219.114 196.698c-.007.018-.014.035-.022.052-3.85 9.327-14.217 20.619-41.739 21.449-4.187.126-7.683-3.165-7.809-7.352-.125-4.188 3.166-7.683 7.352-7.809 10.713-.323 24.297-2.681 28.176-12.075 1.598-3.872 6.033-5.714 9.904-4.116 3.854 1.59 5.698 5.992 4.138 9.851z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.728 196.698c.007.018.014.035.022.052 3.85 9.327 14.217 20.619 41.739 21.449 4.187.126 7.683-3.165 7.809-7.352.125-4.188-3.166-7.683-7.352-7.809-10.713-.323-24.297-2.681-28.176-12.075-1.598-3.872-6.033-5.714-9.904-4.116-3.855 1.59-5.698 5.992-4.138 9.851z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m233.199 225.492c-1.144 3.654-4.125 6.44-7.857 7.299-20.054 4.616-40.338 4.616-60.392 0-3.732-.859-6.712-3.645-7.857-7.299-5.065-16.174-5.066-32.518 0-48.694 1.144-3.654 4.125-6.44 7.857-7.299 20.053-4.616 40.338-4.616 60.392 0 3.732.859 6.712 3.645 7.857 7.299 5.066 16.176 5.065 32.521 0 48.694z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.627 172.686c-1.338-4.271-4.822-7.528-9.184-8.532-23.441-5.396-47.152-5.396-70.593 0-4.362 1.004-7.846 4.261-9.184 8.532-5.922 18.908-5.921 38.013 0 56.919 1.338 4.271 4.822 7.528 9.184 8.532 23.441 5.396 47.152 5.396 70.593 0 4.362-1.004 7.846-4.261 9.184-8.532 5.921-18.906 5.921-38.011 0-56.919zm-12.213 49.105c-.97 3.099-3.498 5.461-6.662 6.189-17.005 3.914-34.206 3.914-51.211 0-3.164-.728-5.692-3.091-6.662-6.189-4.295-13.715-4.296-27.575 0-41.292.97-3.099 3.498-5.461 6.662-6.189 17.005-3.914 34.206-3.914 51.211 0 3.164.728 5.692 3.091 6.662 6.189 4.296 13.718 4.296 27.577 0 41.292z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m352.748 225.492c-1.144 3.654-4.125 6.44-7.857 7.299-20.054 4.616-40.338 4.616-60.392 0-3.732-.859-6.712-3.645-7.857-7.299-5.065-16.174-5.066-32.518 0-48.694 1.144-3.654 4.125-6.44 7.857-7.299 20.053-4.616 40.338-4.616 60.392 0 3.732.859 6.712 3.645 7.857 7.299 5.066 16.176 5.066 32.521 0 48.694z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.176 172.686c-1.338-4.271-4.822-7.528-9.184-8.532-23.441-5.396-47.152-5.396-70.593 0-4.362 1.004-7.846 4.261-9.184 8.532-5.922 18.908-5.921 38.013 0 56.919 1.338 4.271 4.822 7.528 9.184 8.532 23.441 5.396 47.152 5.396 70.593 0 4.362-1.004 7.846-4.261 9.184-8.532 5.921-18.906 5.922-38.011 0-56.919zm-12.212 49.105c-.97 3.099-3.498 5.461-6.662 6.189-17.005 3.914-34.206 3.914-51.211 0-3.164-.728-5.692-3.091-6.662-6.189-4.295-13.715-4.296-27.575 0-41.292.97-3.099 3.498-5.461 6.662-6.189 17.005-3.914 34.206-3.914 51.211 0 3.164.728 5.692 3.091 6.662 6.189 4.296 13.718 4.295 27.577 0 41.292z",
    fill: "url(#SVGID_23_)"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.084 286.543-116.429-44.189c-14.521-5.569-30.808 1.689-36.377 16.21l-7.027 18.324c-14.387 37.514-11.149 73.178 26.365 87.564 19.705 7.557 41.316 1.185 54.02-14.268l47.984 18.402z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.344 336.946c1.491-3.888 1.752-8.151.689-12.177-3.097-11.734-12.005-21.739-24.756-25.564-17.067-5.12-35.676 3.216-43.222 19.358-8.849 18.93-.036 40.974 18.736 48.894 20.632 1.714 40.766-10.208 48.553-30.511z",
    fill: "url(#SVGID_25_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m486.693 498.747c-58.983 5.051-137.095 8.114-222.778 8.114-6.8 0-13.556-.022-20.248-.054l-129.708-130.899c42.831-20.074 89.833-30.92 140.267-30.92 97.176 0 184.564 41.582 245.426 107.962 1.249 1.358 2.477 2.726 3.704 4.095 13.719 15.458 3.932 39.931-16.663 41.702z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.176 376.186-278.645-106.726c-11.525-4.367-24.408 1.445-28.775 12.981l-27.482 72.637c-4.367 11.525 1.456 24.419 12.981 28.764l34.977 13.47 274.572 105.193c19.335-1.086 37.41-2.346 53.976-3.758 5.705-.49 10.58-2.721 14.355-6.022 4.521-3.953 7.069-9.68 7.549-15.666.263-3.277.361-6.546.299-9.802-.75-39.203-24.778-76.038-63.807-91.071z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m58.053 223.929c-6.201.001-12.399-2.26-17.343-6.782-.006-.006-.013-.013-.02-.019-.596-.531-1.484-.523-2.076.015-9.889 9.046-24.802 9.046-34.691-.004-4.919-4.5-5.258-12.138-.756-17.057 4.501-4.919 12.137-5.26 17.058-.756.595.545 1.496.547 2.092-.001 9.888-9.043 24.8-9.043 34.687 0 .008.007.015.013.022.02.596.528 1.483.522 2.073-.017.333-.304.683-.59 1.047-.855 5.392-3.923 12.946-2.733 16.869 2.66 3.706 5.096 2.849 12.117-1.807 16.184-4.913 4.408-11.036 6.612-17.155 6.612z",
    fill: "url(#SVGID_28_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.463 175.946c-11.899.001-22.31-8.151-24.986-20.071-.005-.024-.011-.046-.015-.068-.176-.789-.907-1.292-1.713-1.201-13.303 1.74-25.501-6.834-28.403-19.918-1.444-6.509 2.662-12.958 9.172-14.402 6.505-1.449 12.957 2.662 14.401 9.172.175.791.91 1.298 1.714 1.204 13.265-1.743 25.461 6.807 28.388 19.855.005.021.009.041.014.062.175.786.906 1.302 1.709 1.201 6.554-.856 12.581 3.713 13.517 10.264.943 6.601-3.64 12.716-10.241 13.659-.05.007-.109.015-.16.022-1.14.148-2.276.221-3.397.221z",
    fill: "url(#SVGID_29_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.608 302.041c6.201.001 12.399-2.26 17.343-6.782.007-.006.013-.013.02-.019.596-.531 1.484-.523 2.076.015 9.889 9.046 24.802 9.046 34.691-.004 4.919-4.5 5.258-12.138.756-17.057-4.501-4.919-12.137-5.26-17.058-.756-.595.545-1.496.547-2.092-.001-9.888-9.043-24.8-9.043-34.687 0-.008.007-.015.013-.022.02-.596.528-1.483.522-2.073-.017-.333-.304-.683-.59-1.047-.855-5.392-3.923-12.946-2.733-16.869 2.66-3.706 5.096-2.849 12.117 1.807 16.184 4.912 4.408 11.035 6.612 17.155 6.612z",
    fill: "url(#SVGID_30_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m428.663 254.058c11.899.001 22.31-8.151 24.986-20.071.005-.024.011-.046.015-.068.176-.789.907-1.292 1.713-1.201 13.303 1.74 25.501-6.834 28.403-19.918 1.444-6.509-2.662-12.958-9.172-14.402-6.505-1.449-12.957 2.662-14.401 9.172-.175.791-.91 1.298-1.714 1.204-13.265-1.743-25.461 6.807-28.388 19.855-.005.021-.009.041-.014.063-.175.786-.906 1.302-1.709 1.201-6.554-.856-12.581 3.713-13.517 10.264-.943 6.601 3.64 12.716 10.241 13.659.05.007.109.015.16.022 1.141.147 2.277.22 3.397.22z",
    fill: "url(#SVGID_31_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m471.982 374.586c.866 0 1.745-.093 2.626-.289 6.51-1.444 10.617-7.893 9.172-14.402-2.903-13.084-15.116-21.653-28.403-19.916-.808.097-1.538-.413-1.713-1.201-.005-.024-.01-.047-.015-.07-2.929-13.044-15.122-21.568-28.384-19.849-.051.007-.101.014-.151.021-6.601.943-11.192 7.059-10.249 13.66.937 6.558 6.982 11.117 13.53 10.262.804-.11 1.521.422 1.695 1.203.005.022.01.045.015.067 2.929 13.046 15.114 21.589 28.388 19.85.792-.095 1.538.413 1.713 1.203 1.249 5.629 6.24 9.461 11.776 9.461z",
    fill: "url(#SVGID_32_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCough);
export default __webpack_public_path__ + "static/media/icon-cough.77c1879a5ed66d0d75ab8afe7c77a306.svg";
export { ForwardRef as ReactComponent };